
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations-we-rent/[slug]",
      function () {
        return require("private-next-pages/locations-we-rent/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations-we-rent/[slug]"])
      });
    }
  